import { extendTheme, StyleFunctionProps } from '@chakra-ui/react'

// CDS（CURON Design System）由来のカラー定数。
// Chakra theme token として使うほか、Chakra を経由しない SVG の fill 等から
// import { cdsColors } from 'src/theme/theme' で直接参照することも可能。
export const cdsColors = {
  red: {
    100: '#FFEDEB', // CDS/Red/R100
    300: '#FAA79E', // CDS/Red/R300
    600: '#E2341D', // CDS/Red/R600*
  },
  green: {
    50: '#F7FCFA', // CDS/Green/G50
    700: '#2BA168', // CDS/Green/G700*
    logo: '#008E44', // CDS/Static/Logo Green
  },
  neutralGray: {
    100: '#EEF2F6', // CDS/Neutral Gray/N100
    200: '#D3DDE8', // CDS/Neutral Gray/N200
    400: '#A5B1C0', // CDS/Neutral Gray/N400*
    600: '#6C7E93', // CDS/Neutral Gray/N600*
    900: '#272C33', // CDS/Neutral Gray/N900
  },
  blue: {
    500: '#2097E5', // Figma: アバター内側
  },
} as const

export const fontSizes = {
  xs: '10px',
  sm: '12px',
  md: '14px',
  lg: '16px',
  xl: '18px',
  '2xl': '20px',
  '3xl': '24px',
  '4xl': '28px',
  '5xl': '32px',
  '6xl': '40px',
  '7xl': '48px',
  '8xl': '56px',
  '9xl': '64px',
} as const

export const theme = extendTheme({
  colors: {
    cds: cdsColors,
    // id-doctor に合わせたエラー時の入力欄背景色
    red: {
      50: '#FFF3F2',
    },
  },
  fontSizes,
  components: {
    PinInput: {
      sizes: {
        md: {
          w: '50px',
          h: '64px',
          fontSize: fontSizes.xl,
        },
      },
    },
    Input: {
      baseStyle: {
        field: {
          _invalid: {
            backgroundColor: 'red.50',
            _focus: {
              backgroundColor: 'red.50',
            },
          },
        },
      },
    },
    // Chakra デフォルトの colorScheme が blue のため、枠線・チェック時の塗りとも
    // CDS の緑 (cds.green.700) を明示指定する
    Checkbox: {
      baseStyle: {
        control: {
          border: '1px solid',
          borderColor: 'cds.green.700',
          _checked: {
            bg: 'cds.green.700',
            borderColor: 'cds.green.700',
            color: 'white',
            _hover: {
              bg: 'cds.green.700',
              borderColor: 'cds.green.700',
            },
          },
        },
      },
    },
    // 成功系トーストは Figma のダークトーストに合わせる。
    // error は useToast 側のカスタム render（赤背景）が使われるため対象外
    Alert: {
      variants: {
        solid: (props: StyleFunctionProps) =>
          props.status !== 'error'
            ? {
                container: {
                  bg: 'rgba(49, 53, 65, 0.8)',
                  width: '100%',
                },
              }
            : {},
      },
    },
  },
})
